// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"3a36e9cc","453":"87dcbae5"}[chunkId] + ".chunk.js";
};